// extracted by mini-css-extract-plugin
export default {"shell":"silver-alpha_shell__V1C+D","frame":"silver-alpha_frame__Ygxwt","main":"silver-alpha_main__N27P+"};